<app-vis-dialog class="main-panel" [show]="show" (close)="close()">
    <app-search-bar>
        
        <button (click)="this.initGame()">{{isOver?'開始':'重來'}}</button>
    </app-search-bar>
    <div style="text-align: center;" [ngStyle]="{color:isOver?'red':'black'}">{{msg}}</div>
    <div style="display: flex;">
        <div style="width: 400px;max-height: 450px;display: flex;flex-direction: column;">
            AI策略
            <div style="white-space: pre-wrap;">
                {{prompt1}}
            </div>
            <textarea style="flex-grow: 1;width: 100%;" [(ngModel)]="prompt"></textarea>
        </div>
        <div style="display: flex;flex-wrap: wrap;" [ngStyle]="{width:cellSize*15+'px'}" >
            <ng-container *ngFor="let row of grid;let rowIdx=index">
                <ng-container *ngFor="let col of row;let colIdx=index">
                    <ng-container *ngTemplateOutlet="gridCell;context:{col:colIdx,row:rowIdx,cell:col}"></ng-container>
                </ng-container>
            </ng-container>
        </div>
    </div>
</app-vis-dialog>
<ng-template let-col="col" let-row="row" let-cell="cell" #gridCell>
    <div  [ngStyle]="{width:cellSize+'px',height:cellSize+'px'}" style="position: relative;">        
        <div [ngStyle]="col==0?{left:cellSize/2+'px',width:'50%',top:cellSize/2+'px'}:col==14?{left:'0px',width:'50%',top:cellSize/2+'px'}: {left:'0px',width:'100%',top:cellSize/2+'px'}" style="position: absolute;height: 1px;background-color: black;">
            
        </div>
        <div [ngStyle]="row==0?{top:cellSize/2+'px',height:'50%',left:cellSize/2+'px'}:row==14?{top:'0px',height:'50%',left:cellSize/2+'px'}: {top:'0px',height:'100%',left:cellSize/2+'px'}" style="position: absolute;width: 1px;background-color: black;">
            
        </div>
        <div (click)="cellClick(row,col)" style="position: absolute;border: 1px solid black;" 
            [ngStyle]="{left:cellSize/4+'px',width:'50%',top:cellSize/4+'px', height:'50%',
                        border:cell.type==''?'none': '1px solid black', borderRadius:cellSize+'px',
                        background:cell.type=='b'?'black':cell.type=='w'?'white':'transparent',
                        boxShadow:cell.type&&cell.num==num?'0px 0px 10px #000':''}">
        </div>
    </div>
</ng-template>